export const authTypesEnum = {
  BASIC_AUTH: 'BASIC_AUTH',
} as const

export type AuthTypesEnum = (typeof authTypesEnum)[keyof typeof authTypesEnum]

export type AuthTypes = AuthTypesEnum